import React from 'react';
import { ConfigProvider, TimePicker } from 'antd';
import dayjs from 'dayjs';
import frFR from 'antd/es/locale/fr_FR';
import 'dayjs/locale/fr';

dayjs.locale('fr');
const InputHeure = ({ disabled = false ,value,onChange }) => {
    const timeValue = value ? dayjs(value, 'HH:mm') : null;

  return (
    <ConfigProvider locale={frFR}>
    <TimePicker
      disabled={disabled}
      placeholder="Heure"
      style={{ width: '40%' }} variant='underlined'
      format="HH:mm"
       value={timeValue}
      onChange={(time, timeString) => {
        onChange && onChange(timeString);
      }}
    />
    </ConfigProvider>

  );
};

export default InputHeure;
 